import merge from 'deepmerge';
import { combineReducers } from 'redux';

const lenderCategory = () => (
  state = {
    // inital states here
    lenderCategoryData: null,
  },
  action,
) => {
  if (action.type === 'LENDERCATEGORY_SUCCESS' && action.response.entities) {
    return merge.all([state, action.response.entities], {
      clone: false,
      arrayMerge: (destinationArray, sourceArray) => sourceArray,
    });
  }
  return state;
};

export default combineReducers({
  lenderCategory: lenderCategory(),
});
